// Import modules
import Navigation from './modules/_navigation'
import ObjectFit from './modules/_object-fit'
import Print from './modules/_print'
import HamburgerMenu from './modules/_hamburger-menu'
import VideoModal from './modules/_video-modal'
import Sliders from './modules/_sliders'
import CoverSlider from './modules/_cover-slider'
import StoriesSlider from './modules/_stories-slider'
import Accordion from './modules/_accordion'
import ImageCollage from './modules/_image-collage'
import MuseumsMaps from './modules/_museums-map'
import PressSliders from './modules/_press-slider'
import ActivitiesArchive from './modules/_activities-archive'
import DayProgram from "./modules/_day-program";
import ActivitySlider from "./modules/_activities-slider";


// Use modules
Navigation()
ObjectFit()
Print()
HamburgerMenu()
VideoModal()
Sliders()
CoverSlider()
Accordion()
StoriesSlider()
ImageCollage()
MuseumsMaps()
PressSliders()
ActivitiesArchive()
DayProgram()
ActivitySlider()
/**
 * If you want to use React in this project, just use the function below:
 * require('./app');
 */